const GRAYLOG_URI = /^graylog:\/\/\/([^/]+)(?:\/(.+))?$/;
const resolveGraylogUri = (uri, resolvers) => {
  var _a;
  const match = GRAYLOG_URI.exec(uri);
  if (!match) {
    return null;
  }
  const [, uriSegment, trailing] = match;
  const trailingSegments = (_a = trailing == null ? void 0 : trailing.split("/")) != null ? _a : [];
  const resolver = resolvers.find((candidate) => candidate.uriSegment === uriSegment);
  if (!resolver) {
    return null;
  }
  return resolver.resolve([trailingSegments.at(-1)]);
};
export default resolveGraylogUri;
